import React, {useState} from "react";
import {useTranslation} from "@unibuddy/intl";
import {Select, Stack, Label} from "@unibuddy/patron";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_AREA_OF_STUDY, INTL_NONE_SELECTED} from "../../../../translations/common";
import {INTL_NO_OPTIONS_MESSAGE} from "../../../../translations/mentorCard";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

type Degree = {
    id?: string;
    name?: string;
};

type DegreeInputProps = {
    currentDegree: string;
    selectableDegrees: Degree[];
    onSearch: (filterInput: string, filterName: string) => void;
    containerLoading: boolean;
};

const EmptyDegreeInput = () => {
    const {t} = useTranslation([IntlNamespaces.BLOGS, IntlNamespaces.MENTOR_CARD]);
    return (
        <Stack space="xsmall">
            <Label id="degree">{t(INTL_AREA_OF_STUDY.key, INTL_AREA_OF_STUDY.defaultValue)}</Label>
            <Select id="degree" value="" formatValue={(e: React.FormEvent<HTMLSelectElement>) => e}>
                <option value="">
                    {t(INTL_NO_OPTIONS_MESSAGE.key, INTL_NO_OPTIONS_MESSAGE.defaultValue)}
                </option>
            </Select>
        </Stack>
    );
};

export const DegreeInput = ({
    currentDegree = "",
    selectableDegrees,
    onSearch,
    containerLoading,
}: DegreeInputProps) => {
    const {t} = useTranslation([IntlNamespaces.COMMON]);
    const [selectedDegree, setSelectedDegree] = useState<string>(currentDegree);
    const {trackEvent} = useAnalytics();
    const {slug: universitySlug} = useUniversity();

    const onChange = (event: {target: {value: string}}) => {
        setSelectedDegree(event.target.value);
        onSearch(event.target.value, "degrees");
        trackEvent(sharedEvents.contentFilteredByAreaOfStudy.name, {
            universitySlug,
            areaOfStudyNames: event.target.value,
        });
    };

    if (selectableDegrees.length === 0 && !containerLoading) return <EmptyDegreeInput />;

    return (
        <Stack space="xsmall">
            <Label id="degree">{t(INTL_AREA_OF_STUDY.key, INTL_AREA_OF_STUDY.defaultValue)}</Label>
            <Select
                id="degree"
                value={selectedDegree}
                onChange={onChange}
                formatValue={(e: React.FormEvent<HTMLSelectElement>) => e}
            >
                <option value="">
                    {t(INTL_NONE_SELECTED.key, INTL_NONE_SELECTED.defaultValue)}
                </option>
                {selectableDegrees &&
                    selectableDegrees.map((degree: Degree) => (
                        <option value={degree.id} key={degree.id}>
                            {degree.name}
                        </option>
                    ))}
            </Select>
        </Stack>
    );
};
